const IcClose = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='33' height='33' viewBox='0 0 33 33' fill='none'>
    <path
      d='M7.55727 7.55715C8.07797 7.03645 8.92219 7.03645 9.44289 7.55715L16.5001 14.6143L23.5573 7.55715C24.078 7.03645 24.9222 7.03645 25.4429 7.55715C25.9636 8.07785 25.9636 8.92207 25.4429 9.44277L18.3857 16.5L25.4429 23.5571C25.9636 24.0778 25.9636 24.9221 25.4429 25.4428C24.9222 25.9635 24.078 25.9635 23.5573 25.4428L16.5001 18.3856L9.44289 25.4428C8.92219 25.9635 8.07797 25.9635 7.55727 25.4428C7.03657 24.9221 7.03657 24.0778 7.55727 23.5571L14.6145 16.5L7.55727 9.44277C7.03657 8.92207 7.03657 8.07785 7.55727 7.55715Z'
      fill='#777D7C'
    />
  </svg>
);

export default IcClose;